import { Injectable } from "@angular/core"
import { Route, Router, UrlSegment, UrlTree } from "@angular/router"
import { Store } from "@ngrx/store"
import { iif, map, Observable, of, switchMap } from "rxjs"
import { UserBaseGuard } from "src/app/shared/utils/guards/user-base.guard"


@Injectable({
  providedIn: 'root'
})
export class AgentPreferenceGuard extends UserBaseGuard  {

  constructor(appStore: Store, router: Router) {
    super(appStore, router)
  }

  override canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> {

    return this.isUserAuthenticated$.pipe(
      switchMap(isLogged => !isLogged ?
        this.auth(window.location.href) :
        this.user$.pipe(
          switchMap(user => iif(() => !this.isAgent(user),
            of(this.unauthorizedPageUrl),
            of(true)))
        ))
    )

  }


}
